<template>
  <div class="group-page">
    <h2 class="page-title">大课接龙</h2>
    <el-alert
      title="家长报名占坑；开课前 10 分钟可取消不扣课。下课后对照现场核对名单：没来的踢出，没接龙但到了的补上，核对无误再提交扣课。"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom:16px"
    />

    <div class="toolbar">
      <el-button type="primary" size="small" @click="openCreate">发起接龙</el-button>
      <el-button size="small" @click="load">刷新</el-button>
    </div>

    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="title" label="标题" min-width="140" />
      <el-table-column label="上课时间" width="170">
        <template slot-scope="{ row }">{{ formatTime(row.lessonTime) }}</template>
      </el-table-column>
      <el-table-column label="名额" width="100">
        <template slot-scope="{ row }">{{ row.signupCount || 0 }}/{{ row.capacity }}</template>
      </el-table-column>
      <el-table-column label="扣课时" width="80" prop="hoursPerSeat" />
      <el-table-column label="状态" width="100">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(row)">{{ statusText(row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">核对名单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="发起大课接龙" :visible.sync="createVisible" width="480px" append-to-body destroy-on-close>
      <el-form label-width="120px">
        <el-form-item label="场次标题" required>
          <el-input v-model="form.title" placeholder="如：周三晚大课" />
        </el-form-item>
        <el-form-item label="上课时间" required>
          <el-date-picker
            v-model="form.lessonTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="名额">
          <el-input-number v-model="form.capacity" :min="1" :max="200" />
        </el-form-item>
        <el-form-item label="每人扣课时">
          <el-input-number v-model="form.hoursPerSeat" :min="1" :max="10" />
        </el-form-item>
        <el-form-item label="上课时长(分钟)">
          <el-input-number v-model="form.durationMinutes" :min="30" :max="240" :step="15" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible = false">取消</el-button>
        <el-button type="primary" :loading="creating" @click="submitCreate">发布</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :title="detailTitle"
      :visible.sync="detailVisible"
      size="560px"
      append-to-body
      destroy-on-close
    >
      <div v-if="detail" class="drawer-body">
        <p class="meta">上课：{{ formatTime(detail.session.lessonTime) }}</p>
        <p class="meta">下课：{{ formatTime(detail.lessonEndTime) }}（{{ detail.session.durationMinutes || 90 }} 分钟）</p>
        <p class="meta">报名/取消截止：{{ formatTime(detail.signupDeadline || detail.deductDeadline) }}（开课前 10 分钟）</p>
        <p class="meta">名额：{{ detail.session.signupCount || 0 }}/{{ detail.session.capacity }} · 默认扣 {{ detail.session.hoursPerSeat || 1 }} 课时</p>
        <p class="meta">{{ phaseText }}</p>
        <el-divider>核对名单</el-divider>
        <div class="add-row">
          <el-select
            v-model="addStudentId"
            filterable
            remote
            clearable
            placeholder="搜索姓名/电话，补录到场未接龙学员"
            :remote-method="searchStudents"
            :loading="searching"
            style="flex:1"
          >
            <el-option
              v-for="s in studentOptions"
              :key="s.id"
              :label="s.name + (s.parentPhone ? ' · ' + s.parentPhone : '')"
              :value="s.id"
            />
          </el-select>
          <el-button type="primary" size="small" :loading="adding" :disabled="!addStudentId" @click="addStudent">补录到场</el-button>
        </div>
        <el-table :data="detail.signups || []" size="small" border>
          <el-table-column type="index" width="50" />
          <el-table-column prop="studentName" label="学员" />
          <el-table-column label="本场课时" width="88">
            <template slot-scope="{ row }">{{ row.plannedHours != null ? row.plannedHours : (detail.session.hoursPerSeat || 1) }}</template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="{ row }">{{ signupStatus(row) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="170">
            <template slot-scope="{ row }">
              <el-button v-if="row.status !== 3" type="text" @click="zeroHours(row)">不计课时</el-button>
              <el-button v-if="row.status !== 3" type="text" @click="changeHours(row)">改课时</el-button>
              <el-button
                v-if="row.status !== 3"
                type="text"
                style="color:#DC2626"
                @click="cancelSignup(row)"
              >踢出</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="detail.reviewOpen" class="settle-bar">
          <el-button type="primary" :loading="settling" @click="settle">核对无误，提交扣课</el-button>
        </div>
        <p v-else-if="detail.settled" class="meta">本场已提交并扣课</p>
        <p v-else class="meta">下课后再核对比对现场人员，确认后提交扣课</p>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { listGroupSessions, getGroupSession, createGroupSession, cancelGroupSignup, adjustGroupSignupHours, addGroupSignup, settleGroupSession, getStudents } from '../api'

export default {
  name: 'GroupLesson',
  data() {
    return {
      loading: false,
      list: [],
      createVisible: false,
      creating: false,
      form: {
        title: '',
        lessonTime: '',
        capacity: 12,
        hoursPerSeat: 1,
        durationMinutes: 90,
        remark: ''
      },
      detailVisible: false,
      detail: null,
      currentId: null,
      addStudentId: null,
      studentOptions: [],
      searching: false,
      adding: false,
      settling: false
    }
  },
  computed: {
    detailTitle() {
      if (!this.detail || !this.detail.session) return '核对名单'
      return this.detail.session.title || '核对名单'
    },
    phaseText() {
      if (!this.detail) return ''
      if (this.detail.settled) return '已核对扣课'
      if (this.detail.reviewOpen) return '待核对：请对照现场人员调整名单后提交'
      if (this.detail.signupOpen) return '报名中'
      return '已截止报名，下课后再核对提交'
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatTime(t) {
      if (!t) return '-'
      return String(t).replace('T', ' ').slice(0, 16)
    },
    statusText(row) {
      if (row.status === 0) return '已关闭'
      if (row.status === 2) return '已扣课'
      const start = new Date(String(row.lessonTime).replace(' ', 'T')).getTime()
      const end = start + (row.durationMinutes || 90) * 60000
      const now = Date.now()
      if (now >= end) return '待核对'
      if (now >= start) return '上课中'
      if (now >= start - 10 * 60 * 1000) return '已截止报名'
      return '报名中'
    },
    statusType(row) {
      if (row.status === 0) return 'info'
      if (row.status === 2) return 'success'
      const start = new Date(String(row.lessonTime).replace(' ', 'T')).getTime()
      const end = start + (row.durationMinutes || 90) * 60000
      const now = Date.now()
      if (now >= end) return 'warning'
      if (now >= start) return ''
      if (now >= start - 10 * 60 * 1000) return 'info'
      return ''
    },
    signupStatus(row) {
      const hours = row.plannedHours != null ? row.plannedHours : 1
      if (row.status === 3) return '已取消'
      if (hours === 0) return row.status === 2 ? '不计课时' : '将不计课时'
      if (row.status === 2) return '已扣课'
      return '已占坑'
    },
    async load() {
      this.loading = true
      try {
        const res = await listGroupSessions({ page: 1, size: 50, upcomingOnly: true })
        this.list = (res.data && res.data.records) || []
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      const d = new Date()
      d.setDate(d.getDate() + 1)
      d.setHours(19, 0, 0, 0)
      const p = n => (n < 10 ? '0' + n : '' + n)
      this.form = {
        title: '',
        lessonTime: `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} 19:00:00`,
        capacity: 12,
        hoursPerSeat: 1,
        durationMinutes: 90,
        remark: ''
      }
      this.createVisible = true
    },
    async submitCreate() {
      if (!this.form.title || !this.form.lessonTime) {
        return this.$message.warning('请填写标题与上课时间')
      }
      this.creating = true
      try {
        await createGroupSession({
          ...this.form,
          createdBy: localStorage.getItem('username') || 'admin'
        })
        this.$message.success('已发布')
        this.createVisible = false
        this.load()
      } finally {
        this.creating = false
      }
    },
    async openDetail(row) {
      this.currentId = row.id
      this.addStudentId = null
      this.studentOptions = []
      const res = await getGroupSession(row.id)
      this.detail = res.data || null
      this.detailVisible = true
    },
    async refreshDetail() {
      const res = await getGroupSession(this.currentId)
      this.detail = res.data || null
      this.load()
    },
    cancelSignup(row) {
      this.$confirm('确认踢出？未到课不扣课时。', '踢出名单', { type: 'warning' })
        .then(async () => {
          await cancelGroupSignup(this.currentId, row.id, '未到课，已从名单移除')
          this.$message.success('已踢出')
          await this.refreshDetail()
        })
        .catch(() => {})
    },
    zeroHours(row) {
      this.$confirm('中途离开或身体不适，本场不计课时。若已扣课将退回。', '不计课时', { type: 'warning' })
        .then(async () => {
          await adjustGroupSignupHours(this.currentId, row.id, 0, '中途离开，不计课时')
          this.$message.success('已设为不计课时')
          await this.refreshDetail()
        })
        .catch(() => {})
    },
    changeHours(row) {
      const current = row.plannedHours != null ? row.plannedHours : (this.detail.session.hoursPerSeat || 1)
      this.$prompt('本场扣除课时（0 表示不计课时）', '调整课时', {
        inputValue: String(current),
        inputPattern: /^(10|[0-9])$/,
        inputErrorMessage: '请输入 0～10 的整数'
      }).then(async ({ value }) => {
        const hours = parseInt(value, 10)
        await adjustGroupSignupHours(this.currentId, row.id, hours, hours === 0 ? '不计课时' : '管理员调整课时')
        this.$message.success('已调整')
        await this.refreshDetail()
      }).catch(() => {})
    },
    async searchStudents(keyword) {
      const q = (keyword || '').trim()
      if (!q) {
        this.studentOptions = []
        return
      }
      this.searching = true
      try {
        const res = await getStudents({ page: 1, size: 20, keyword: q, courseType: 1 })
        this.studentOptions = (res.data && res.data.records) || []
      } finally {
        this.searching = false
      }
    },
    async addStudent() {
      if (!this.addStudentId) return
      this.adding = true
      try {
        await addGroupSignup(this.currentId, this.addStudentId, '现场到课，管理员补录')
        this.$message.success('已补录')
        this.addStudentId = null
        await this.refreshDetail()
      } finally {
        this.adding = false
      }
    },
    settle() {
      const n = (this.detail.signups || []).length
      this.$confirm('确认按当前名单提交扣课？共 ' + n + ' 人。没来的请先踢出，没接龙但到了的请先补录。', '提交扣课', { type: 'warning' })
        .then(async () => {
          this.settling = true
          try {
            const res = await settleGroupSession(this.currentId)
            const deducted = res.data && res.data.deducted
            this.$message.success('已扣课 ' + (deducted != null ? deducted : n) + ' 人')
            await this.refreshDetail()
          } finally {
            this.settling = false
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-title { margin: 0 0 16px; font-size: 20px; color: #1E293B; }
.toolbar { margin-bottom: 12px; }
.drawer-body { padding: 0 20px 24px; }
.meta { margin: 6px 0; color: #64748b; font-size: 13px; }
.add-row { display: flex; gap: 8px; margin-bottom: 12px; align-items: center; }
.settle-bar { margin-top: 16px; text-align: right; }
</style>
